"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _reactHelmet = require("react-helmet");
var _nuiIntlRuntime = _interopRequireWildcard(require("@concur/nui-intl-runtime"));
var _SkipLink = _interopRequireDefault(require("@concur/nui-widgets/SkipLink"));
var ListingsActions = _interopRequireWildcard(require("./listingsModule"));
!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./style/listings.css") : void 0;
var _CommonSections = _interopRequireDefault(require("../shared/CommonSections"));
var _utils = require("../utils");
var _withAppContext = require("../HOCs/withAppContext");
var _FilterBar = _interopRequireDefault(require("./FilterBar"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var Home = /*#__PURE__*/function (_Component) {
  function Home() {
    _classCallCheck(this, Home);
    return _callSuper(this, Home, arguments);
  }
  _inherits(Home, _Component);
  return _createClass(Home, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var categorySlug = (0, _get2.default)(this.props, 'params.category');
      if (categorySlug) {
        this.props.setCategorySlug(categorySlug);
      }
      if (this.props.context.isPublic && (0, _utils.canUseDOM)() && window.utag) {
        (0, _utils.sendPublicView)();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var categorySlug = (0, _get2.default)(this.props, 'params.category');
      if (categorySlug) {
        if (this.props.listings.categories.length > 0) {
          var isValidCategory = this.props.listings.categories.some(function (category) {
            var subCategoryMatch = false;
            if (category.subcategories.length > 0) {
              subCategoryMatch = category.subcategories.some(function (subCategory) {
                return subCategory.slug.toLowerCase() === categorySlug.toLowerCase();
              });
            }
            return subCategoryMatch || category.slug.toLowerCase() === categorySlug.toLowerCase();
          });
          if (!isValidCategory) {
            window.location = '/404';
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        listingsReadyState = _this$props.listings.listingsReadyState,
        getTitle = _this$props.context.getTitle,
        formatter = _this$props.formatter;
      var localeData = (0, _nuiIntlRuntime.getLocaleData)(this.props);
      var translations = window.NUI_TRANSLATIONS; // eslint-disable-line global-require, import/no-dynamic-require

      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactHelmet.Helmet, {
        title: getTitle(_utils.HOME)
      }), /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.default, {
        messages: translations,
        localeData: localeData
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_SkipLink.default, {
        label: formatter.formattedMessage({
          id: 'SkipToConnections'
        }),
        url: "#listings-section"
      }), listingsReadyState === ListingsActions.LISTINGS_FETCHED && /*#__PURE__*/_react.default.createElement(_FilterBar.default, null), /*#__PURE__*/_react.default.createElement(_CommonSections.default, {
        enableLiveUpdate: true,
        lazyLoadListings: "ondemand"
      }))));
    }
  }]);
}(_react.Component);
Home.propTypes = {
  listings: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  setCategorySlug: _propTypes.default.func,
  context: _propTypes.default.shape({
    getTitle: _propTypes.default.func.isRequired
  }).isRequired
};
function mapStateToProps(state) {
  return {
    listings: state.listings,
    userPrefs: state.userPrefs
  };
}
var _default = exports.default = (0, _withAppContext.withAppContext)((0, _reactRedux.connect)(mapStateToProps, {
  setCategorySlug: ListingsActions.setCategorySlug
})((0, _nuiIntlRuntime.withFormatter)(Home)));